module.exports = __webpack_public_path__ + "img/doctor.887cf751.png";